import { render, staticRenderFns } from "./ListEstadocivilPage.vue?vue&type=template&id=575b9b24"
import script from "./ListEstadocivilPage.vue?vue&type=script&lang=js"
export * from "./ListEstadocivilPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports